// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"LoadingSpinner_loadingSpinner__2N5mX","spinner":"LoadingSpinner_spinner__F8zRK","spinnerContainer":"LoadingSpinner_spinnerContainer__n7bOK"};